import Inspector from './inspector';
const { RichText, InnerBlocks } = wp.blockEditor;

const Edit = ({ attributes, setAttributes }) => {
  const { title, description, nameButton } = attributes;

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <div className="CardPlan TabsCompany__content TabsCompany__content-editPanel">
        <div className="CardPlan-price TabsCompany__information">
          <RichText
            className="Typography title-5 left color-blue-dark margin-base"
            tagName="h3"
            placeholder="titulo do card"
            value={title}
            keepPlaceholderOnFocus
            onChange={(title) => setAttributes({ title })}
          />
          <RichText
            className="Typography text left color-black margin-base"
            tagName="p"
            placeholder="Descrição do card"
            value={description}
            keepPlaceholderOnFocus
            onChange={(description) => setAttributes({ description })}
          />
        </div>

        <nav className="CardPlan-list TabsCompany__content-list">
          <ul>
            <InnerBlocks
              template={[['app/plans-corporate-checklist-item']]}
              allowedBlocks={['app/plans-corporate-checklist-item']}
            />
          </ul>
        </nav>

        <a class="Button CardPlan-link">
          <RichText
            tagName="span"
            placeholder="Texto do botão"
            value={nameButton}
            keepPlaceholderOnFocus
            onChange={(nameButton) => setAttributes({ nameButton })}
          />
        </a>
      </div>
    </>
  );
};

export default Edit;
